export const IN_PROGRESS = 1
export const FINISHED = 2
export const FAILED = 3
export const NEW = 4
